import script from "./company-avatar.vue?vue&type=script&setup=true&lang=js"
export * from "./company-avatar.vue?vue&type=script&setup=true&lang=js"

import "./company-avatar.vue?vue&type=style&index=0&id=edc28410&lang=css"

const __exports__ = script;

export default __exports__